import { api } from "./api";

export const colorsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getColors: builder.query({
      query: () => "api/Stock/Colors",
      providesTags: ["colors"],
    }),
    addColor: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Colors",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["colors"],
    }),
    editColor: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Colors",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["colors"],
    }),
    deleteColor: builder.mutation({
      query: (colorId) => ({
        url: `api/Stock/Colors?ColorID=${colorId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["colors"],
    }),
  }),
});

export const {
  useGetColorsQuery,
  useAddColorMutation,
  useEditColorMutation,
  useDeleteColorMutation,
} = colorsApi;
